<svg
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
>
  <path
    d="M22.56 12.25C22.56 11.47 22.49 10.72 22.36 10H12V14.255H17.92C17.665 15.63 16.89 16.795 15.725 17.575V20.335H19.28C21.36 18.42 22.56 15.6 22.56 12.25Z"
    fill="#4285F4"
  />
  <path
    d="M12 23.0001C14.97 23.0001 17.46 22.0151 19.28 20.3351L15.725 17.5751C14.74 18.2351 13.48 18.6251 12 18.6251C9.13501 18.6251 6.71001 16.6901 5.84501 14.0901H2.17001V16.9401C3.98001 20.5351 7.70001 23.0001 12 23.0001Z"
    fill="#34A853"
  />
  <path
    d="M5.845 14.0901C5.625 13.4301 5.5 12.7251 5.5 12.0001C5.5 11.2751 5.625 10.5701 5.845 9.91006V7.06006H2.17C1.4 8.59292 0.999321 10.2847 1 12.0001C1 13.7751 1.425 15.4551 2.17 16.9401L5.845 14.0901Z"
    fill="#FBBC05"
  />
  <path
    d="M12 5.375C13.615 5.375 15.065 5.93 16.205 7.02L19.36 3.865C17.455 2.09 14.965 1 12 1C7.70001 1 3.98001 3.465 2.17001 7.06L5.84501 9.91C6.71001 7.31 9.13501 5.375 12 5.375Z"
    fill="#EA4335"
  />
</svg>
